import styled from "styled-components";

import { Button } from "./Button";
import { Typography } from "./Typography";

/**
 * [共通パーツ]一覧画面の「さらに表示」ボタン
 */

type Props = {
  onClick: () => void;
};

const Container = styled.div`
  width: 100%;
  height: 50px;
  max-width: 250px;
  margin: 10px auto 0;
`;

export function LoadMoreButton({ onClick }: Props) {
  return (
    <Container>
      <Button onClick={onClick} buttonType="primary">
        <Typography size={2}>さらに表示</Typography>
      </Button>
    </Container>
  );
}
